import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AssemblyPaymentTerminalModel } from './models/assembly-payment.terminal';

@Component({
  template: require('./assembly-payments.terminal.actions.component.html')
})
export class AssemblyPaymentsTerminalActionComponent {
  @Input() record: AssemblyPaymentTerminalModel;

  @Output() onPairClick   : EventEmitter<any> = new EventEmitter();
  @Output() onRemoveClick : EventEmitter<any> = new EventEmitter();
  @Output() onUnpairClick : EventEmitter<any> = new EventEmitter();
}